export default __webpack_public_path__ + "static/media/LoginBackground.ff8dcc4b.jpg";